import React, { Component } from "react";
import EkoModal from "../../components/elements/EkoModal";
import { toastr } from "react-redux-toastr";
import Api from "../../util/Api";
import { EkoFormInputText, EkoFormSelect } from "../../components/elements/EkoForm";

class ModalLicenseInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      draft: {},
      templates: [],
      saving: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.showModal && nextProps.showModal !== this.props.showModal) {
      const rows =
        nextProps.licenseRows && nextProps.licenseRows.rows
          ? nextProps.licenseRows.rows
          : [];
      this.setState({ draft: { ...(rows[0] || {}) } }, () => {
        this.fetchTemplates();
      });
    }
  }

  fetchTemplates = () => {
    if (this.state.templates && this.state.templates.length > 0) return;
    Api.get("/transportationContract/licenseInfoTemplates", (res, err) => {
      if (err) return;
      const templates = Array.isArray(res && res.templates) ? res.templates : [];
      const normalized = templates.map((t) => ({
        ...t,
        label: t.label || t.plate_no || t.registration_no || "",
      }));
      this.setState({ templates: normalized });
    });
  };

  closeModal = () => {
    this.props.closeModal();
  };

  onTemplateSelect = (value) => {
    const id = parseInt(value, 10);
    if (!id) return;
    const selected = (this.state.templates || []).find((t) => parseInt(t.id, 10) === id);
    if (!selected) return;
    this.setState({
      draft: {
        ...this.state.draft,
        plate_no: selected.plate_no || "",
        registration_no: selected.registration_no || "",
        brand_model: selected.brand_model || "",
        tax_office_no: selected.tax_office_no || "",
        owner_full_name: selected.owner_full_name || "",
        owner_address: selected.owner_address || "",
        owner_phone: selected.owner_phone || "",
      },
    });
  };

  onFieldChange = (id, value) => {
    this.setState({
      draft: {
        ...this.state.draft,
        [id]: value,
      },
    });
  };

  onSave = () => {
    const draft = this.state.draft || {};
    const hasAnyValue = Object.keys(draft).some((k) => draft[k] !== null && draft[k] !== "");
    if (hasAnyValue && !draft.plate_no) {
      toastr.warning("Dikkat!", "Plaka No boş olamaz");
      return;
    }
    this.props.saveLicense({
      rows: [{ ...draft }],
    });
    this.props.closeModal();
  };

  render() {
    const templateInputProps = {
      onChange: (_, value) => this.onTemplateSelect(value),
      onMount: () => {},
      formData: {},
      errors: {},
    };
    const inputProps = {
      onChange: this.onFieldChange,
      onMount: () => {},
      formData: this.state.draft || {},
      errors: {},
    };

    return (
      <EkoModal
        bsSize={"large"}
        dialogClassName={""}
        showModal={this.props.showModal}
        title={"Ruhsat Bilgileri"}
        onHide={this.closeModal}
        spinner={this.state.saving}
        modalBodyStyle={{ padding: "15px 20px" }}
      >
        <div className="row">
          <div className="col-md-12">
            <EkoFormSelect
              searchable={true}
              isVertical={true}
              {...templateInputProps}
              id={"license_template_id"}
              defaultText={"ÖNCEKİ KAYITLARDAN SEÇİN"}
              optionId={"id"}
              options={this.state.templates}
              optionValue={"label"}
              label={"Kayıtlı Ruhsat Bilgileri"}
            />
          </div>
          <div className="col-md-6">
            <EkoFormInputText
              {...inputProps}
              id={"plate_no"}
              type={"text"}
              isVertical={true}
              label={"Plaka No"}
            />
          </div>
          <div className="col-md-6">
            <EkoFormInputText
              {...inputProps}
              id={"registration_no"}
              type={"text"}
              isVertical={true}
              label={"Tescil No"}
            />
          </div>
          <div className="col-md-6">
            <EkoFormInputText
              {...inputProps}
              id={"brand_model"}
              type={"text"}
              isVertical={true}
              label={"Marka Model"}
            />
          </div>
          <div className="col-md-6">
            <EkoFormInputText
              {...inputProps}
              id={"tax_office_no"}
              type={"text"}
              isVertical={true}
              label={"V.D. No"}
            />
          </div>
          <div className="col-md-12">
            <EkoFormInputText
              {...inputProps}
              id={"owner_full_name"}
              type={"text"}
              isVertical={true}
              label={"Ruhsat Sahibi Adı Soyadı"}
            />
          </div>
          <div className="col-md-12">
            <EkoFormInputText
              {...inputProps}
              id={"owner_address"}
              type={"textarea"}
              rows={3}
              isVertical={true}
              label={"Araç Sahibi Adres"}
            />
          </div>
          <div className="col-md-12">
            <EkoFormInputText
              {...inputProps}
              id={"owner_phone"}
              type={"text"}
              isVertical={true}
              label={"Araç Sahibi Tel"}
            />
          </div>
          <div className="col-md-12" style={{ textAlign: "right", marginTop: 6 }}>
            <button
              type="button"
              className="btn btn-default"
              onClick={this.closeModal}
            >
              İptal
            </button>
            <button
              type="button"
              className="btn btn-primary"
              style={{ marginLeft: 8 }}
              onClick={this.onSave}
            >
              Kaydet
            </button>
          </div>
        </div>
      </EkoModal>
    );
  }
}

export default ModalLicenseInfo;
